import { useContext, useEffect } from 'react';
import { HistoryContext } from '@src/scenario-editor/providers/history.context';
import { historyAtom, cursorAtom } from '@src/atoms';
import { useAtom } from 'jotai';

interface UseHistoryHookProps {
  key: string;
}
export const useNodesHistory = ({ key }: UseHistoryHookProps) => {
  const context =  useContext(HistoryContext);
  const [, setHistory] = useAtom(historyAtom);
  const [, setCursor] = useAtom(cursorAtom);

  useEffect(() => {
    return () => {
      setHistory([]);
      setCursor(-1);
    }
  }, []);

  useEffect(() => {
    setHistory([]);
    setCursor(-1);
  }, [key]);

  if (!context) {
    throw new Error('useHistory must be used within a HistoryProvider');
  }

  return context;
}
